// App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Layout Components
import Sidebar from './components/layout/sidebar';
import TopBar from './components/layout/topbar';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import ContentModerationDashboard from './pages/ContentModerationDashboard';
import ContentModerationPage from './pages/ContentModerationPage';
import AnalyticsPage from './pages/AnalyticsPage';
import AdminSettingsPage from './pages/AdminSettingsPage';
import FlaggedContentPage from './pages/FlaggedContentPage';
import MessageFilterPage from './pages/MessageFilterPage';
import FlaggedGoGetsPage from './pages/FlaggedGoGetsPage';

const AppLayout = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return(
    <div className="min-h-screen bg-gray-50">
      <TopBar onMenuToggle={handleMenuToggle} />
      <div className="flex">
        <Sidebar 
          isMobileMenuOpen={isMobileMenuOpen} 
          onClose={() => setIsMobileMenuOpen(false)} 
        />
        <main className="flex-1 p-8 pt-20 px-8 
          md:ml-64 
          md:px-8
        ">
          {children}
        </main>
      </div>
    </div>
  )
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <DashboardPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/users"
            element={
              <ProtectedRoute requiredPermissions={['manage_users']}>
                <AppLayout>
                  <UsersPage />
                </AppLayout>
            </ProtectedRoute>
            }
          />

          <Route
            path="/moderation"
            element={
              <ProtectedRoute requiredPermissions={['manage_content', 'delete_content']} requireAllPermissions={false}>
                <AppLayout>
                  <ContentModerationDashboard />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          {/* Individual content type routes */}
          <Route
            path="/moderation/all"
            element={
              <ProtectedRoute requiredPermissions={['manage_content', 'delete_content']} requireAllPermissions={false}>
                <AppLayout>
                  <ContentModerationPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/moderation/messages"
            element={
              <ProtectedRoute requiredPermissions={['manage_content']}>
                <AppLayout>
                  <FlaggedContentPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/moderation/gogets"
            element={
              <ProtectedRoute requiredPermissions={['manage_content']}>
                <AppLayout>
                  <FlaggedGoGetsPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/message-filter"
            element={
              <ProtectedRoute requiredPermissions={['manage_content']}>
                <AppLayout>
                  <MessageFilterPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />


          <Route
            path="/analytics"
            element={
              <ProtectedRoute requiredPermissions={['view_analytics']}>
                <AppLayout>
                  <AnalyticsPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <ProtectedRoute requiredPermissions={['manage_settings']}>
                <AppLayout>
                  <AdminSettingsPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;